/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-get, ember/require-tagless-components, no-restricted-properties, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import { stripDiacritics } from 'ember-power-select/utils/group-utils';

export default class SurveyDialog extends Component {
  @action
  setNewAnswer(value) {
    this.newAnswer = value;
  }

  @action
  setQuestion(value) {
    this.question = value;
  }

  @action
  setSearchFilter(value) {
    this.searchFilter = value;
  }

  // Services
  @service
  paperToaster;

  @service
  session;

  @service
  store;

  // Properties
  @tracked searchFilter = '';

  @tracked
  searchResult = null;

  get searchResults() {
    if (isEmpty(this.searchFilter)) {
      return [];
    }
    let filter = stripDiacritics(this.searchFilter).toLowerCase();
    return this.allSurveys.filter((survey) => {
      let question = stripDiacritics(survey.question).toLowerCase();
      return question.indexOf(filter) !== -1;
    });
  }

  @tracked
  question = '';
  @tracked
  answers = ['Yes', 'No'];
  @tracked
  newAnswer = '';
  @tracked
  saveInProgress = false;

  // Attributes
  @tracked
  selectSurveyDialog = false;

  survey = null;
  onChange() {}
  closeDialog() {}

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    // If a survey is provided, set our internal properties for editing.
    // this.survey is a Proxy, which isn't "empty" - so we need to check the ID from inside it.
    if (!isEmpty(this.get('survey.id'))) {
      this.question = this.get('survey.question');
      this.answers = this.get('survey.answers').toArray();
    } else {
      this.reset();
    }
  }

  @action
  addAnswer(answer) {
    if (!this.answers.includes(answer)) {
      this.answers = [...this.answers, answer];
    }
    this.newAnswer = '';
  }

  @action
  removeAnswer(answer) {
    this.answers = this.answers.filter((a) => a !== answer);
  }

  @action
  dropAnswer({ sourceList, sourceIndex, targetList, targetIndex }) {
    if (sourceList === targetList && sourceIndex === targetIndex) {
      return;
    }

    let answers = [...this.answers];
    const [item] = answers.splice(sourceIndex, 1);
    answers.splice(targetIndex, 0, item);
    this.answers = answers;
  }

  @action
  maybeAddAnswer(evt) {
    if (!isEmpty(this.newAnswer) && ['Enter', 'Return'].includes(evt.key)) {
      this.answers = [...this.answers, this.newAnswer];
      this.newAnswer = '';
    }
  }

  @action
  openSelectSurveyDialog(result) {
    this.selectSurveyDialog = true;
    this.searchResult = result;
  }

  @action
  closeSelectSurveyDialog() {
    this.selectSurveyDialog = false;
    this.searchResult = null;
  }

  @action
  selectSurvey() {
    this.onChange(this.searchResult);
    this.reset();
    this.closeDialog();
  }

  @action
  copyDetail(searchResult) {
    let newSurvey = {
      authorId: this.get('session.person'),
      schoolId: this.get('session.school'),
      question: searchResult.question,
      answers: searchResult.answers.toArray(),
    };
    let survey = this.store.createRecord('surveys/survey', newSurvey);

    survey
      .save()
      .then((survey) => {
        this.onChange(survey);
        this.reset();
        this.closeDialog();

        this.paperToaster.show(`Survey copied successfully.`, {
          duration: 4000,
          position: 'top right',
        });
      })
      .catch(() => {
        this.paperToaster.show(`Error copying survey!`, {
          duration: 8000,
          position: 'top right',
        });
      });
  }

  @action
  save() {
    this.saveInProgress = true;
    let surveyId = this.get('survey.id');
    let survey;
    if (isEmpty(surveyId)) {
      // Creating a new survey.
      let newSurvey = {
        authorId: this.get('session.person'),
        schoolId: this.get('session.school'),
      };
      survey = this.store.createRecord('surveys/survey', newSurvey);
    } else {
      survey = this.store.peekRecord('surveys/survey', surveyId);
    }
    survey.setProperties({
      question: this.question,
      answers: this.answers,
    });

    survey
      .save()
      .then((survey) => {
        this.onChange(survey);
        this.reset();
        this.closeDialog();

        this.paperToaster.show(`Survey saved successfully.`, {
          duration: 4000,
          position: 'top right',
        });
      })
      .catch(() => {
        this.paperToaster.show(`Error saving survey!`, {
          duration: 8000,
          position: 'top right',
        });
      });
  }

  @action
  remove() {
    this.onChange(null);
    this.reset();
    this.closeDialog();
  }

  @action
  cancel() {
    this.reset();
    this.closeDialog();
  }

  reset() {
    this.question = '';
    this.newAnswer = '';
    this.answers = ['Yes', 'No'];
    this.saveInProgress = false;
  }
}
